// import axios from '@/utils/request'
import request from "../utils/request";

class packageApi {

  // 获取时间轴数据
  static getTimeLines(options) {
    return request.get('/cz-goods/v1/timeLines',{params:options})
  }

  //收藏商品列表
  static getCollectsList(options) {
    return request.get('/cz-goods/v1/users/collects',{params:options})
  }

  //获取浏览商品列表
  static getViewHistoryList(options) {
    return request.get('/cz-goods/v1/products/viewHistorys',{params:options})
  }

  //在背的包、换过的包和想背的包数量
  static getPackageCount() {
    return request.get('/cz-order/v1/orders/count')
  }


}

export default packageApi;
